import {
  IonButton,
  IonButtons,
  IonCheckbox,
  IonFooter,
  IonIcon,
  IonItem,
  IonLabel
} from "@ionic/react";
import { closeOutline } from "ionicons/icons";
import { useDispatch, useSelector } from "react-redux";
import { setCheckAll, setShowMassiveSign, setUncheckAll } from "../../../store/documentsSignerList";
import { selectIsEveryDocumentChecked } from "../../../store/documentsSignerList/selectors/selectIsEveryDocumentChecked";
import { selectMassiveSign } from "../../../store/documentsSignerList/selectors/selectMassiveSign";
import { selectSegmentSelected } from "../../../store/documentsSignerList/selectors/selectSegmentSelected";
import { SignAllButton } from "./SignAllButton";
import { SignStatus } from "./SignStatus";

export const SignMassiveToolbar = () => {
  const dispatch = useDispatch();
  const isEveryDocumentChecked = useSelector(selectIsEveryDocumentChecked);
  const massiveSign = useSelector(selectMassiveSign);
  const segment = useSelector(selectSegmentSelected);

  const handleCheck = () => {
    isEveryDocumentChecked ? dispatch(setUncheckAll()) : dispatch(setCheckAll());
  };

  return (
    <>
      {massiveSign && segment === "pending" && (
        <>
          <SignStatus />
          <IonFooter color="secondary">
            <IonItem color="secondary">
              <IonCheckbox
                checked={isEveryDocumentChecked}
                onClick={() => handleCheck()}
                slot="start"
              />
              <IonLabel>{isEveryDocumentChecked ? "Quitar todos" : "Seleccionar todos"}</IonLabel>
              <IonButtons slot="end">
                <IonButton
                  fill="solid"
                  onClick={() => dispatch(setShowMassiveSign(false))}
                  color="danger"
                  size="small"
                >
                  <IonIcon icon={closeOutline} slot="start"></IonIcon>
                  <span>Cancelar</span>
                </IonButton>
                <SignAllButton />
              </IonButtons>
            </IonItem>
          </IonFooter>
        </>
      )}
    </>
  );
};
